import { styled } from '@mui/material/styles';
import MuiLink from '@mui/material/Link';

export const Link = styled(MuiLink)`
  text-decoration: none;
  border-bottom: 1px dotted ${(props) => props.theme.palette.primary.main};
  cursor: pointer;
`;
